import { render, staticRenderFns } from "./hotelhead.vue?vue&type=template&id=2d70a20b"
import script from "./hotelhead.vue?vue&type=script&lang=js"
export * from "./hotelhead.vue?vue&type=script&lang=js"
import style0 from "./hotelhead.vue?vue&type=style&index=0&id=2d70a20b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports